import { z } from "zod"
import { Element } from "../element"

// Version 1 ---------------------
export const DrawerSettingsV1 = z.object({
  cardBackgroundBlur: z.union([z.literal(true), z.literal(false)]),
  containerRadius: z.string(),
})

export type TDrawerSettingsV1 = z.infer<typeof DrawerSettingsV1>

export const DrawerElementV1 = z.object({
  id: z.string(),
  name: z.literal("drawer"),
  settings: DrawerSettingsV1,
  children: z.lazy(() => z.array(Element)),
})

export type TDrawerElementV1 = z.infer<typeof DrawerElementV1>

// Latest ---------------------
export const DrawerElement = DrawerElementV1
export type TDrawerElement = TDrawerElementV1
export const DrawerSettings = DrawerSettingsV1
export type TDrawerSettings = TDrawerSettingsV1
